import React from "react";

const Icon = ({ className, name, size }) => (
  <i className={`lc-icon lc-icon-${size} lc-icon-${name} ${className}`} />
);

export default Icon;
